module.exports = __webpack_public_path__ + "img/usdt.f883a30c.png";